import {
  BOOK_ONLINE_PATH,
  BOUTIQUE_DEVELOPERS_PATH,
  COLLECTIONS_PATH,
  CONTACT_PATH,
  DEALERS_PATH,
  PORTFOLIO_PATH,
  OUR_PROCESS_PATH,
  THE_BRAND_PATH,
} from '@/consts/routes';

const collection = slug => `${COLLECTIONS_PATH}/${slug}`;

export const WEBSITE_STUDIO_CONTACT = {
  addressLines: ['131 Ormont Drive', 'North York, M9L 2S3'],
  email: 'info@niico.com',
  phone: '416 745 6426',
  phoneHref: 'tel:+14167456426',
};

export const WEBSITE_FOOTER_COMPANY_LINKS = [
  { label: 'The Brand', href: THE_BRAND_PATH },
  { label: 'Our Process', href: OUR_PROCESS_PATH },
  { label: 'Dealers', href: DEALERS_PATH },
  {
    label: 'Multi-Unit Projects',
    href: BOUTIQUE_DEVELOPERS_PATH,
  },
  { label: 'Contact Us', href: CONTACT_PATH },
];

export const WEBSITE_FOOTER_PORTFOLIO_LINKS = [
  { label: 'All Collections', href: PORTFOLIO_PATH },
  { label: 'Kitchens', href: collection('kitchens') },
  { label: 'Bathroom', href: collection('bath') },
  { label: 'Wardrobe', href: collection('wardrobe') },
  { label: 'Custom Millwork', href: collection('custom-millwork') },
];

export const WEBSITE_FOOTER_BOOK_CTA = {
  title: 'Schedule a consultation',
  label: 'Book Now',
  href: BOOK_ONLINE_PATH,
};

export const WEBSITE_FOOTER_NEWSLETTER = {
  title: 'Subscribe to our newsletter',
  description: 'Design inspiration, project highlights, and studio news — delivered to your inbox.',
  placeholder: 'Enter your email',
  buttonLabel: 'Subscribe',
  successMessage: 'Thank you for subscribing.',
  alreadySubscribedMessage: 'You are already subscribed to our newsletter.',
};
